import React from 'react';
import { Button, Modal, Header, Icon } from 'semantic-ui-react'
import {useTranslation} from "react-i18next";
import '../localization/config';

export interface IConfirmationModal {
  title: string;
  message: string;
  icon?: any;
  open: boolean;

  onClose(): void;
  onConfirm(): void;
}

const ConfirmationModal = (props: IConfirmationModal) => {
  const {title, message, icon, open, onClose, onConfirm} = props;

  const { t } = useTranslation();

  return (
    <Modal
      open={open}
      onClose={onClose}
    >
      <Header icon={icon} content={title} />
      <Modal.Content>
        <p>
          {message}
        </p>
      </Modal.Content>
      <Modal.Actions>
        <Button color='red' onClick={onClose}>
          <Icon name='remove' />
          {t('general.no')}
        </Button>
        <Button color='green' onClick={onConfirm}>
          <Icon name='checkmark' />
          {t('general.yes')}
        </Button>
      </Modal.Actions>
    </Modal>
  )
}

export default ConfirmationModal;